import palette from './palette.json';

/**
 * Theme colours for JavaScript (chart.js / recharts / inline SVG), from the same palette.json
 * that tailwind.config.js uses for the Tailwind tokens - change a colour there, not in a component.
 */
export const colors = {
    primary: palette.primary,
    primaryDark: palette['primary-dark'],
    primaryLight: palette['primary-light'],
    accent: palette.accent,
    accentSoft: palette['accent-soft'],
    background: palette.background,
    surface: palette.surface,
    line: palette.line,
    lineStrong: palette['line-strong'],
    textMain: palette['text-main'],
    textMuted: palette['text-muted'],
    success: palette.success,
    danger: palette.danger,
};

export default colors;
